<template>
  <div>
    <v-tabs v-model="tab" vertical>
      <v-tab key="general">{{$t('general')}}</v-tab>
      <v-tab
        key="combo"
        v-if="value.dataType == 'Combo'"
      >{{ $t('entities.actionField.props.combo')}}</v-tab>
      <v-tabs-slider></v-tabs-slider>
      <v-tabs-items v-model="tab">
        <v-tab-item key="general">
          <v-form ref="form" v-model="valid">
            <v-container>
              <v-text-field
                v-model="value.label"
                class="mr-2"
                :label="$t('entities.actionField.props.label')"
                clearable
                :rules="$isRequiredRule"
              ></v-text-field>

              <v-select
                :label="$t('entities.actionField.props.dataType')"
                :items="$actionDataType"
                v-model="value.dataType"
              ></v-select>
              <v-checkbox
                :label="$t('entities.actionField.props.isRequired')"
                v-model="value.isRequired"
              ></v-checkbox>
            </v-container>
          </v-form>
        </v-tab-item>
        <v-tab-item key="combo">
          <action-field-combo-tab-list v-model="value.combo"></action-field-combo-tab-list>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import actionFieldComboTabList from './actionFieldComboTabList'
import formValidationMixin from '../../../mixins/formValidationMixin'
export default {
    name:'action-field-form',
    props:['value'],
    mixins:[formValidationMixin],
    components:{actionFieldComboTabList},
    data(){
        return{
            tab:null,
            valid:true,
        }
    }

}
</script>

<style>

</style>